import { useState } from "react";
import { getApiError } from "../services/siteService";
export function useErrorView() {
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);
  return {
    async handleError(code) {
      const error = await getApiError(code);
      setError(error);
      setShowError(true);
    },
    errorViewProps: {
      error,
      showError,
      onClose: () => {
        setShowError(false);
      }
    }
  };
}
